import { render, staticRenderFns } from "./u-tit-subtit.vue?vue&type=template&id=ed936ebe&scoped=true&"
import script from "./u-tit-subtit.vue?vue&type=script&lang=js&"
export * from "./u-tit-subtit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed936ebe",
  null
  
)

export default component.exports